import { leftToRightMark } from "@jti/fe-common";

type ReduceReturnType = {
  format?: string;
  position?: number;
};

// Function to format phone number
// format: +{2} {3} {3} {3}
// phone number string: 48123123123
// output +48 123 123 123

export const formatRegularPhoneNumber = (phoneNumber: string, format = "+{2} {3} {3} {3}"): string => {
  if (!phoneNumber) {
    return "";
  }
  const cleanNum = phoneNumber.replace(/\D/g, "");
  const numberPattern = /\d+/g;
  const match = format.match(numberPattern);
  const phoneFormatted = match?.reduce(
    (acc: ReduceReturnType, curr: string) => {
      const replacedFormat = (acc?.format || "").replace(
        `{${curr}}`,
        cleanNum.slice(acc.position, Number(acc.position) + Number(curr))
      );
      return {
        format: replacedFormat,
        position: Number(curr) + Number(acc.position),
      };
    },
    { format, position: 0 }
  );
  return `${leftToRightMark}${phoneFormatted?.format}` || "";
};
